import { Api } from "@/services/api.js";

class Ssourl extends Api {
  merchantId = process.env.VUE_APP_MERCHANT_ID;

  constructor() {
    super();
  }

  async genurl(memberUuid = '', app = '', nextUrl = '') {
    const config = {
      method: 'POST',
      url: `${this.apiHost}/identities/v1/merchants/${this.merchantId}/members/${memberUuid}/sso-url`,
      headers: {
        'Content-Type': 'application/json'
      },
      body: {
        app: app,
        nextUrl: nextUrl
      }
    };

    return this.$http(config);
  }
}

export const ssourlApi = new Ssourl();
